// extracted by mini-css-extract-plugin
module.exports = {"root":"TopSection_root__rLbec","backgroundTitle":"TopSection_backgroundTitle__5fKGe","body":"TopSection_body__dsbi9"};